module.exports = __webpack_public_path__ + "img/details.6b71285c.svg";